import React, { useRef, useEffect } from "react"
import { gsap, TweenLite } from "gsap";
import ReactMarkdown from 'react-markdown';
gsap.registerPlugin(TweenLite);

const LoadInScreen = ({title, subtitle, logo, logoAlt}) => {
  const circleRef = useRef(null);
  const loadIn = useRef(null);
  useEffect(() => {
      const pathLength = circleRef.current.getTotalLength();
      TweenLite.set(circleRef.current, {strokeDasharray:pathLength});
      TweenLite.set(loadIn.current, {opacity: 0});

      TweenLite.to(loadIn.current, {opacity: 1, duration: 1.5})
      TweenLite.fromTo(circleRef.current, 4.5, {strokeDashoffset: pathLength, delay: 1.5}, {strokeDashoffset:0});
      TweenLite.to(loadIn.current, { opacity: 0, duration: 2, delay: 7.5})
      window.setTimeout(function() {
          loadIn.current.classList.add("visually-hidden");
          localStorage.setItem("visited", "true");
      }, 10000)
  }, []);

  return  (
    <div className="load-in" ref={loadIn}>
      <div>
        <div className="circle">
          <svg viewBox="0 0 36 36">
            <path
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                fill="none"
                stroke="#C2C2C2"
                opacity="0.3"
                strokeWidth=".1"
              />
            <path
              className="blue"
              ref={circleRef}
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="#2258CF"
              strokeWidth=".25"
              strokeDasharray="0,100"
            />
          </svg>
        </div>
        <h2>{title}</h2>
        <ReactMarkdown source={subtitle} className="text"/>
        <div className="img-container">
          <img src={logo} alt={logoAlt} />
        </div>
      </div>
    </div>
  )
  
}

export default LoadInScreen;